<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.integracao.endereco"
        ref="RkmDataTable"
        sort-by="endereco_inicio"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                v-if="authorize('integracao-endereco-destroy')"
                :disabled="item.endereco_executado === 'Sim'"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'endereco_arquivo', label: 'Arquivo', name: 'integracao_endereco.arquivo', searchable: true, sortable: true},
                {key: 'endereco_inicio', label: 'Início', name: 'integracao_endereco.inicio', searchable: true, sortable: true},
                {key: 'endereco_fim', label: 'Fim', name: 'integracao_endereco.fim', searchable: true, sortable: true},
                {key: 'endereco_executado', label: 'Executado', name: 'integracao_endereco.executado', searchable: true, sortable: true},
                {key: 'endereco_erro', label: 'Erro', name: 'integracao_endereco.erro', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    inject: ['repositories'],
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.integracao.endereco.destroy(item.endereco_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', 'Deseja realmente excluir a integração de endereço?', destroy, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
}
</script>